import { Injectable } from '@angular/core';
import deepmerge from 'deepmerge';

import { renderEnvironment } from 'environments/render/environment';
import { RenderConfiguration } from 'render/render.configuration';
import { SPAConfigurationService } from 'shared/services/spa-configuration.service';


@Injectable({ providedIn: 'root' })
export class RenderConfigurationService extends SPAConfigurationService<RenderConfiguration> {

  constructor() {
    super(renderEnvironment);
  }

  public merge(override: Partial<RenderConfiguration> | undefined): void {
    if (override === undefined) {
      return;
    }
    const merged = deepmerge(
      renderEnvironment as object,
      override as object,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      { arrayMerge: (_, source) => source }
    ) as RenderConfiguration;
    try {
      this.validateBreakpoints(merged.breakpoints);
    } catch (error) {
      throw new Error(`Breakpoints provided by configuration are invalid. ${error}`);
    }
    this.innerConfig = merged;
  }

}
